import { useCallback } from 'react';
import { useAuthStore } from '../store/authStore';
import { authService } from '../services/auth';
import type { LoginResult } from '@shared/types';

/**
 * 认证状态Hook
 * 封装认证相关的状态和操作
 */
export function useAuth() {
  const { token, user, setUser, setToken, clearAuth } = useAuthStore();

  /** 登录 */
  const login = useCallback(
    async (username: string, password: string): Promise<LoginResult> => {
      const result = await authService.login(username, password);
      setToken(result.token);
      setUser(result.user);
      localStorage.setItem('token', result.token);
      localStorage.setItem('user', JSON.stringify(result.user));
      return result;
    },
    [setToken, setUser],
  );

  /** 登出 */
  const logout = useCallback(async () => {
    try {
      await authService.logout();
    } catch {
      // 忽略登出错误
    }
    clearAuth();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }, [clearAuth]);

  /** 刷新用户信息 */
  const refreshProfile = useCallback(async () => {
    const profile = await authService.getProfile();
    setUser(profile as any);
    return profile;
  }, [setUser]);

  return {
    token,
    user,
    isAuthenticated: !!token,
    login,
    logout,
    refreshProfile,
  };
}
